import React from "react";
import { SectionHeader, ContainerWrapper, SectionWrapper } from "../Utils";

//Wrap the link function
function CardContainer(props) {
  return (
    <SectionWrapper backgroundColor={props.bgColor} pt="1rem" pb="1rem">
      <ContainerWrapper textAlign="center">
        {props.title ? <SectionHeader mt="0.25rem" mb="0.25rem" pb="1rem" pt="1rem">{props.title}</SectionHeader> : ''}
        {props.children}
      </ContainerWrapper>
    </SectionWrapper> 
  );
}

const CardBody = (props) => (
  <div className="card__body" style={{padding: props.cardBodyPad}}>
    <SectionHeader size="small" pt="0.25rem" pb="0.25rem">{props.name}</SectionHeader>
    { props.subText && <small className="my-0 py-2">{props.subText}</small> }
</div>
);

const CardTop = (props) => {
  if(props.banner) {
    return (
      <div className="card__top">
      <div className="card__opacify"></div>
      <picture>
        <source media="(max-width: 600px)" srcSet={props.banner.small || props.banner.big}/>
        <source media="(min-width: 768px)" srcSet={props.banner.big} />
        <img src={props.banner.big} alt={props.name} />
      </picture>
      </div>
    );
  }
  return undefined;
}

const CardYear = (props) => (
  <div className="w-100 network__calendar">
    <span className="calendar__year">
      <small>Launched</small>
      {props.year}
    </span>
  </div>
);

export { CardContainer, CardBody, CardTop, CardYear }


// WEBPACK FOOTER //
// ./src/Components/Networks/Card.js